/*
*   File : portfolio-summary.js
*   Author : https://evoqins.com
*   Description : Portfolio summary page
*   Integrations : NA
*   Version : 1.0.0
*/

import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

//Style
import style from "../../Styles/Component/portfolio.module.scss";

//Custom components
import { EmptyScreen, Loader } from '../../Component/Others';
import { AlphaBasketCard } from '../../Component/Cards';
import { APIService } from '../../Service';
import { _scrollToTop } from '../../Helper';

// Assets
import EmptyPortfolio from '../../Assets/Images/EmptyScreen/empty-portfolio.webp';



// Custom data
// const OPTIONS = [
//     {
//         value: 1,
//         label: "alphaBasket",
//     },
//     {
//         value: 2,
//         label: "alphaBasket Pro",
//     },
// ];

// const FILTER_OPTIONS = [
//     {
//         id: 1,
//         label: "All",
//     },
//     {
//         id: 2,
//         label: "alphaBasket"
//     },
//     {
//         id: 3,
//         label: "alphaBasket pro"
//     },
//     // {
//     //     id: 4,
//     //     label: "alphaStocks"
//     // },
//     // {
//     //     id: 5,
//     //     label: "alphaOptions"
//     // },
//     // {
//     //     id: 6,
//     //     label: "alphaMF"
//     // },
//     {
//         id: 7,
//         label: "Own Baskets"
//     },
// ];

const PortfolioSummary = () => {


    const USER_DATA = useSelector((store) => store.Reducer.USER_DATA);
    const scrollRef = useRef(null);
    const navigate = useNavigate();

    // const [selected, setSelected] = useState([OPTIONS[0]]);
    const [portfolioList, setPortFolioList] = useState({});
    const [toggleFilter, setToggleFilter] = useState(false);
    // const [selectedFilter, setSelectedFilter] = useState([]);
    const [dataLoading, setDataLoading] = useState(true);

    useEffect(() => {
        // API Call
        _getPortfolioData();
        // Scroll the page to top
        _scrollToTop();
    }, []);

    useEffect(() => {
        if (toggleFilter === true) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
    }, [toggleFilter]);

    // handle toggle filter 
    // const _handleToggleFilter = () => {
    //     setToggleFilter(!toggleFilter);
    //     if (scrollRef.current) {
    //         scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    //     }
    // };

    // handle select risk filter
    // const _handleFilter = (id) => {

    //     const filter_ids = FILTER_OPTIONS.map(option => option.id);

    //     if (id == 1) {
    //         setSelectedFilter(selectedFilter.includes(1) ? [] : [1, ...filter_ids]);
    //     } else {
    //         if (selectedFilter.includes(id)) {
    //             setSelectedFilter(selectedFilter.filter(risk_id => risk_id !== id));
    //         } else {
    //             setSelectedFilter([...selectedFilter, id]);
    //         }
    //     }
    // };

    // handle clear filter 
    // const _handleClearFilter = () => {
    //     setSelectedFilter([]);
    // };

    // handle apply filter 
    // const _handleApplyFilter = () => {
    //     setToggleFilter(false);
    // };

    // handle cancel filter 
    // const _handleCancelFilter = () => {
    //     setToggleFilter(false);
    //     setSelectedFilter([]);
    // };

    // handle navigate to portfolio detail page
    const _handleNavigateToDetail = (product) => {
        navigate("detail", {
            state: {
                product
            }
        });
    };

    // handle navigate to explore page
    const _handleStartInvesting = () => {
        navigate("/explore");
    };


    // ===================================== //
    // ============ API CALLS ============== //

    // Get portfolio list
    const _getPortfolioData = async () => {

        let url = "portfolio/list";
        let data = {
            "page_num": 1,
            "user_id": USER_DATA.unique_identifier,
            "portfolio_type": "Basket",
            "tenant_id": USER_DATA.referral_master_info.creator_id,
        };

        const response = await APIService(url, data);
        if (response.status_code === 200) {
            setPortFolioList(response.data);
        } else {
            setPortFolioList("");
        }
        setDataLoading(false);
    };

    return (
        <>
            {
                dataLoading ?
                    <Loader wrapperClassName="min-vh-100 margin-200px-top" />
                    :
                    <>

                        <section className={`${style.e_portfolio_summary_wrapper} e-bg-white border-radius-16 pb-5 margin-26px-bottom min-h-100vh`}>
                            {
                                portfolioList && portfolioList.active_portfolio.length !== 0 ?
                                    <>
                                        <div className={`${style.e_top_section} border-radius-16 p-3 p--sm-4`}>
                                            <h4 className='e-font-18-res e-primary-font-clash-display e-text-white e-font-20 e-font-weight-500 line-height-24px'>
                                                Portfolio
                                            </h4>

                                            {/* category select */}
                                            {/* <CustomSelectBox value={selected}
                                            options={OPTIONS}
                                            borderRadius="100px"
                                            background="#FFFFFF"
                                            padding="2px 8px"
                                            width="144px"
                                            fontSize="14px"
                                            menuWidth="100%"
                                            wrapperClass="padding-12px-tb"
                                            selected={true}
                                            menuPortalTarget={document.body}
                                            selectChange={(id) => setSelected(id)} /> */}

                                            <div ref={scrollRef} className='row gap-sm-2 flex-wrap g-3'>
                                                {/* Current Value and Invested Amount */}
                                                <div className="col-12 col-sm-auto">
                                                    <div className={`${style.e_amount_wrapper}  d-flex justify-content-between  gap-0px-res gap-64px p-3 border-radius-8`}>
                                                        <div className='d-flex flex-column gap-1'>
                                                            <p className='mb-0 e-text-magnolia e-alt-font-lato e-font-12 e-font-weight-600 line-height-20px'>
                                                                Current Value
                                                            </p>
                                                            <p className='e-font-16-res  mb-0 e-text-white e-alt-font-lato e-font-18 e-font-weight-600 line-height-24px'>
                                                                ₹{Number(portfolioList.total_current_value).toLocaleString("en-IN")}
                                                            </p>
                                                        </div>
                                                        <div className='d-flex flex-column gap-1'>
                                                            <p className='mb-0 e-text-magnolia e-alt-font-lato e-font-12 e-font-weight-600 line-height-20px'>
                                                                Invested Amount
                                                            </p>
                                                            <p className='e-font-16-res mb-0 e-text-white e-alt-font-lato e-font-18 e-font-weight-600 line-height-24px'>
                                                                ₹{Number(portfolioList.total_current_investment).toLocaleString("en-IN")}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Total Returns */}
                                                <div className={`col-6 col-sm-auto`}>
                                                    <div className='e-bg-dutch-white d-flex flex-column gap-1 p-3 border-radius-8'>
                                                        <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-12 e-font-weight-600 line-height-20px'>
                                                            {portfolioList.return_total_data.label}
                                                        </p>
                                                        <p className={`${portfolioList.return_total_data.value < 0 ? "e-text-red" : "e-text-islamic-green"} e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-24px`}>
                                                            {portfolioList.return_total_data.value_str}
                                                            {
                                                                portfolioList.return_total_data.label === "Total Returns" &&
                                                                <span className={`${portfolioList.total_returns_per < 0 ? "e-text-red" : "e-text-islamic-green"} e-font-12 line-height-20px`}>
                                                                    ({portfolioList.total_returns_per}%)
                                                                </span>
                                                            }
                                                        </p>
                                                    </div>
                                                </div>

                                                {/* Today’s Returns  */}
                                                {/* <div className='col-6 col-sm-auto'>
                                                <div className={`${style.e_today_returns_wrapper} d-flex  flex-column gap-1 p-3 border-radius-8`}>
                                                    <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-12 e-font-weight-600 line-height-20px'>
                                                        Today’s Returns
                                                    </p>
                                                    <p className='e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-16 e-font-weight-600 line-height-24px'>
                                                        ₹{Number(portfolioList.realized_profit_loss_amount).toLocaleString("en-IN")}
                                                        <span className={`${Number(portfolioList.realized_profit_loss_amount) < 0 ? "e-text-red" : "e-text-islamic-green"} e-font-12 line-height-20px`}>
                                                            ({portfolioList.realized_profit_loss_per.toLocaleString("en-IN")}%)
                                                        </span>
                                                    </p>
                                                </div>
                                            </div> */}

                                            </div>
                                        </div>

                                        {/* Investments */}
                                        <div className='p-3'>
                                            <div className='row'>
                                                <div className='col-12 col-sm-10 col-md-8 col-lg-6'>
                                                    <div className='d-flex justify-content-between align-items-center'>
                                                        <h6 className='mb-0 e-primary-font-clash-display e-text-black e-font-16 e-font-weight-500 line-height-24px'>
                                                            Investments
                                                        </h6>

                                                        {/* Filter */}
                                                        {/* <div className='position-relative'>
                                                        <div className='d-flex gap-6px align-items-center e-border-0-5-ocean-blue e-bg-magnolia px-3 padding-10px-tb border-radius-100 cursor-pointer'
                                                            onClick={_handleToggleFilter}>
                                                            <div className='d-flex position-relative'>
                                                                <img src={require("../../Assets/Images/Other/filter.svg").default}
                                                                    width={18} />
                                                                <span class="position-absolute top-0 left-84-per translate-middle badge rounded-pill e-bg-filter-count e-text-white e-alt-font-lato e-font-8 e-font-weight-700 line-height-10px px-1 padding-1px-top padding-2px-bottom">
                                                                    2
                                                                </span>
                                                            </div>
                                                            <p className='mb-0 e-text-chinese-black e-alt-font-lato e-font-14 e-font-weight-600 line-height-20px'>
                                                                Filter
                                                            </p>
                                                        </div>

                                                        {toggleFilter &&
                                                            <>
                                                                <OverLay isOpen={toggleFilter} onClose={_handleCancelFilter} />
                                                                <BasketFilterModal type={2}
                                                                    options={FILTER_OPTIONS}
                                                                    selected={selectedFilter}
                                                                    handleSelect={_handleFilter}
                                                                    handleClear={_handleClearFilter}
                                                                    handleCancel={_handleCancelFilter}
                                                                    handleApply={_handleApplyFilter} />
                                                            </>
                                                        }
                                                    </div> */}
                                                    </div>
                                                    <div className='pt-3'>
                                                        {/* Alpha baskets */}
                                                        <div className='pb-3'>
                                                            {portfolioList.active_portfolio.map((product, key) => (
                                                                <div key={key} className='mb-3' >
                                                                    <AlphaBasketCard product={product}
                                                                        category={product.strategy_type}
                                                                        type={3}
                                                                        handleClick={() => _handleNavigateToDetail(product)} />
                                                                </div>
                                                            ))}
                                                        </div>

                                                        {/* Own basket */}
                                                        {/* {
                                                            BASKET_DATA.map((data, key) => (
                                                                <div key={key}>
                                                                    <CustomBasketCard type={1}
                                                                        basket={data} />
                                                                </div>
                                                            ))} */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <div className="p-4">
                                        <h4 className='e-font-18-res e-primary-font-clash-display e-text-primary-color e-font-20 e-font-weight-500 line-height-24px'>
                                            Portfolio
                                        </h4>
                                        <EmptyScreen
                                            type={1}
                                            emptyScreenImage={EmptyPortfolio}
                                            description="You haven't invested yet. Invest now and start growing your wealth."
                                            btnLabel="Start Investing"
                                            onClick={_handleStartInvesting} />
                                    </div>
                            }
                        </section>

                    </>

            }
        </>
    )
}

export default PortfolioSummary;
